import React from "react";
import { useDocumentMeta } from "../components/useDocumentMeta";

function PrivacyPolicy() {
  useDocumentMeta(
    "Privacy policy",
    "How BoldBrave and Logikfabriken collect, use and protect your personal data.",
  );

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <p className="kicker">Legal</p>
          <h1 className="page-title">Privacy policy</h1>
          <p className="page-lead">
            How we handle the personal data you share with us, and the rights
            you have over it.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container legal-content">
          <p className="legal-updated">Last updated: June 2026</p>

          <h2>Who we are</h2>
          <p>
            This site is run jointly by BoldBrave AB and Logikfabriken AB
            ("we", "us"), who collaborate as Red Hat delivery partners building
            Internal Developer Platforms. We are the joint controllers of the
            personal data described below. For any privacy matter you can reach
            us at{" "}
            <a href="mailto:magnus@bold-n-brave.com">magnus@bold-n-brave.com</a>.
          </p>

          <h2>What we collect</h2>
          <p>We only collect data you choose to give us:</p>
          <ul>
            <li>
              <strong>Contact &amp; booking forms.</strong> When you fill in our
              form or book a meeting, we collect details such as your name, work
              email, company and anything you write in the message field.
            </li>
            <li>
              <strong>Email and phone.</strong> If you contact us directly, we
              keep that correspondence to respond and follow up.
            </li>
          </ul>
          <p>
            We do not knowingly collect special categories of data, and we do
            not use the site for advertising or profiling.
          </p>

          <h2>How we use it</h2>
          <ul>
            <li>To reply to your enquiry and schedule meetings.</li>
            <li>
              To understand what you need and prepare for our conversation.
            </li>
            <li>
              To send relevant follow-ups about your enquiry, where you have
              agreed to it.
            </li>
          </ul>
          <p>
            Our legal basis is your consent and our legitimate interest in
            responding to people who reach out to us.
          </p>

          <h2>Who processes it for us</h2>
          <p>
            We use trusted service providers to operate the site and handle
            enquiries, including HubSpot (forms, meeting scheduling and CRM) and
            Google Firebase (hosting). These providers process data on our
            behalf under their own data-processing terms, and some may store
            data outside the EU/EEA under appropriate safeguards.
          </p>

          <h2>How long we keep it</h2>
          <p>
            We keep your data only as long as needed to handle your enquiry and
            any resulting relationship, after which it is deleted or anonymised.
          </p>

          <h2>Your rights</h2>
          <p>
            Under the GDPR you can request access to your data, correction or
            deletion, restriction of or objection to processing, and data
            portability. You can also withdraw consent at any time and lodge a
            complaint with your supervisory authority (in Sweden, the
            Integritetsskyddsmyndigheten, IMY). To exercise any of these, email
            us at{" "}
            <a href="mailto:magnus@bold-n-brave.com">magnus@bold-n-brave.com</a>.
          </p>

          <h2>Changes to this policy</h2>
          <p>
            We may update this policy from time to time. The "last updated" date
            above always reflects the current version.
          </p>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
